interface FilterChipsProps {
  unreadOnly: boolean;
  highRelevance: boolean;
  onUnreadChange: (unread: boolean) => void;
  onHighRelevanceChange: (high: boolean) => void;
  resultCount?: number;
  showUnread?: boolean;
  showScore?: boolean;
  scoreThreshold?: number;
}

export function FilterChips({
  unreadOnly,
  highRelevance,
  onUnreadChange,
  onHighRelevanceChange,
  resultCount,
  showUnread = true,
  showScore = true,
  scoreThreshold = 80,
}: FilterChipsProps) {
  const noFilter = !unreadOnly && !highRelevance;

  return (
    <div className="filter-chips">
      <button
        className={`chip${noFilter ? " active" : ""}`}
        onClick={() => {
          onUnreadChange(false);
          onHighRelevanceChange(false);
        }}
      >
        Alle
      </button>

      {showUnread && (
        <button
          className={`chip${unreadOnly ? " active" : ""}`}
          onClick={() => onUnreadChange(!unreadOnly)}
        >
          Ungelesen
        </button>
      )}

      {showScore && (
        <button
          className={`chip${highRelevance ? " active" : ""}`}
          onClick={() => onHighRelevanceChange(!highRelevance)}
        >
          Score &gt; {scoreThreshold}
        </button>
      )}

      {resultCount !== undefined && (
        <span className="chip-count">{resultCount} Ergebnisse</span>
      )}
    </div>
  );
}
